import React from "react";

export const SidebarSeparator: React.FC = () => <hr className="mx-8 my-4 border-t border-gray-400 px-3" />;
